import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-[#0b0b0b] py-16 md:py-24 px-4 relative overflow-hidden border-t border-white/5" data-id="element-126">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#c9a24a]/5 via-transparent to-transparent pointer-events-none" data-id="element-127"></div>

      <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-128">
        <div className="bg-[#141418] border border-white/10 rounded-2xl md:rounded-3xl p-8 md:p-12 shadow-2xl flex flex-col items-center" data-id="element-129">
          <div className="bg-[#c9a24a]/10 p-4 rounded-full mb-6 md:mb-8 border border-[#c9a24a]/30" data-id="element-130">
            <ShieldCheckIcon className="w-12 h-12 md:w-16 md:h-16 text-[#c9a24a]" data-id="element-131" />
          </div>

          <h2 className="text-2xl md:text-4xl font-black text-white leading-tight mb-4" data-id="element-132">
            Probalo sin riesgo
          </h2>

          <p className="text-gray-400 text-base md:text-xl font-medium max-w-xl mx-auto leading-relaxed" data-id="element-133">
            Tenés garantía. Si sentís que el material no te sirve o no es lo que
            esperabas, podés pedir la devolución de tu dinero.
          </p>

          <div className="mt-8 pt-6 border-t border-white/10 w-full max-w-md" data-id="element-134">
            <p className="text-gray-500 text-xs md:text-sm font-semibold uppercase tracking-widest" data-id="element-135">
              Compra 100% segura
            </p>
          </div>
        </div>
      </div>
    </section>;
}